import { Paper, SxProps, Tab, Tabs } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useCallback, useMemo } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useTypedParams } from 'react-router-typesafe-routes/dom';
import { AppRoutes } from '~/app/app.routes';
import { AuthService } from '~/service/service.auth';
import { useService } from '~/shared/service/service.base';

const sxContainer: SxProps = {
	px: 1,
	pt: 1,
	pb: 0,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '24px',
	width: '100%',
};

type PostEditTab = 'general' | 'comments';

export const PostEditRoute = observer(() => {
	const [auth] = useService(AuthService);
	const nav = useNavigate();
	const { id } = useTypedParams(AppRoutes.PostEdit);

	const handleChangeTab = useCallback(
		(_: unknown, tab: PostEditTab) => {
			if (!id) return;
			switch (tab) {
				case 'general':
					nav(AppRoutes.PostEdit.buildPath({ id }), { replace: true });
					break;
				case 'comments':
					nav(AppRoutes.PostEditCommentList.buildPath({ id }), { replace: true });
					break;
			}
		},
		[nav, id],
	);

	const { pathname } = window.location;

	const tab = useMemo(() => {
		if (!id) return 'general';
		if (pathname.startsWith(AppRoutes.PostEdit.buildPath({ id }))) return 'general';
		else if (pathname.startsWith(AppRoutes.PostEditCommentList.buildPath({ id }))) return 'comments';
	}, [id, pathname]);

	return (
		<Paper elevation={0} sx={sxContainer}>
			<Tabs
				value={tab}
				onClick={e => console.log('tab clicked', e)}
				onChange={handleChangeTab}
				aria-label="user tabs"
				centered
			>
				<Tab label="General" value="general" />
				<Tab label="Comments" value="comments" disabled={!auth.can('postComment', 'READ')} />
			</Tabs>
			<Outlet />
		</Paper>
	);
});
